import { useQuery } from '@tanstack/react-query';
import { clientApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/**
 * Client options for a picker. An empty term falls back to the default
 * client list, which is the same data `useClients` caches.
 */
export function useClientSearch(term: string, enabled = true) {
  const trimmed = term.trim();
  return useQuery({
    queryKey: trimmed
      ? queryKeys.organization.clientSearch(trimmed)
      : queryKeys.organization.clients(),
    queryFn: ({ signal }) =>
      trimmed
        ? clientApiClient.searchClients(trimmed, toCancelToken(signal))
        : clientApiClient.getClients('', toCancelToken(signal)),
    enabled,
    staleTime: 5 * 60_000,
    placeholderData: (prev) => prev,
    meta: { suppressErrorToast: true, errorContext: 'client search' },
  });
}
